import React from 'react';
import ReferralListPage from './components/ReferralListPage';

// This file acts as the parent route for /referral-list
// Add any route-level logic (e.g., meta, wrappers) here if needed

export default function Referral() {
  // Example: set document title (optional)
  React.useEffect(() => {
    document.title = 'Provider Referrals | Loop';
  }, []);

  return <ReferralListPage />;
}
